import { render } from "./MyAsset.vue?vue&type=template&id=4fc93c36&scoped=true&ts=true"
import script from "./MyAsset.vue?vue&type=script&lang=ts"
export * from "./MyAsset.vue?vue&type=script&lang=ts"

import "./MyAsset.vue?vue&type=style&index=0&id=4fc93c36&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fc93c36"]])

export default __exports__